import type {FileDataTypeEnum} from './FileDataTypeEnum';

export type FileData = {
  fileId: string;
  name: string;
  fileUri: string;
  remoteId: string | null;
  createdAt: string | null;
  createdBy: string | null;
  documentType: FileDataTypeEnum | null;
  fileFileId?: string | null;
};
